import { Box, Fade, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import QRCode, { useQRLink } from '../../common/QRCode';
import { formStyles } from '../../onboarding/styles';
import { images } from '../../assets/images';
import { useMobile } from '../../common/hooks';
import { appEnvironment } from '../../common/environment';

export default function QRForm() {
  const { t } = useTranslation();

  const mobile = useMobile();
  const link = useQRLink();

  return (
    <Fade in={true}>
      <Box sx={formStyles.container}>
        <Typography className="large-label" component={'span'}>
          <Typography component={'span'} className="large-label gray">
            {t('next')}
          </Typography>
          {t('downloadTheApp')}
        </Typography>

        <Stack
          justifyContent={'center'}
          alignItems="center"
          gap={'20px'}
          className={mobile ? 'w-full' : ''}
        >
          <Stack
            className={`rounded-[36px] bg-mint px-[20px] pb-[20px] ${
              mobile
                ? 'max-w-[360px] w-auto self-stretch pt-[80px] pb-[50px] min-w-[0px]'
                : 'w-[410px] min-w-[410px]'
            }`}
            gap={'10px'}
            onClick={() => {
              if (mobile) {
                window.location.href = link;
              }
            }}
          >
            {mobile && (
              <Stack
                direction={'row'}
                alignItems={'center'}
                justifyContent={'center'}
              >
                <Typography className="title white">
                  {mobile ? t('tapToDownloadTheApp') : t('downloadTheApp')}
                </Typography>
              </Stack>
            )}

            <Stack
              className={`rounded-[120px] mt-standard ${
                mobile ? '' : 'bg-white w-[240px] h-[240px]'
              }`}
              justifyContent={'center'}
              alignItems={'center'}
              alignSelf={'center'}
            >
              {mobile ? (
                <Box
                  component={'img'}
                  src={appEnvironment.theme.images.tapToDownloadLogo}
                />
              ) : (
                <QRCode size={150} />
              )}
            </Stack>

            <Typography
              className={`footer-note white text-center ${
                mobile ? 'py-[30px]' : 'py-[10px]'
              }`}
            >
              {(mobile ? t('tapTheLogo') : t('scanTheQRCode')).replace(
                /syd/gi,
                appEnvironment.theme.appName
              )}
            </Typography>

            <Stack
              direction={'row'}
              gap={'10px'}
              alignItems={'center'}
              justifyContent={'center'}
            >
              <Box component={'img'} src={images.v2.onboarding.new.apple} />
              <Box component={'img'} src={images.v2.onboarding.new.google} />
            </Stack>
          </Stack>
        </Stack>
      </Box>
    </Fade>
  );
}
